<template>
    <div>
        <div class="form">
            <div class="form-section-heading">
                {{ trans('users.headline.reporting_restrictions') }}
            </div>

            <div class="extendable-card-list">
                <div class="extendable-card-list__card" v-for="(group, index) in restrictionGroups" :key="index">
                    <button class="extendable-card-list__delete" :title="trans('buttons.remove')" @click.prevent="() => removeCard(index)">
                        &times;
                    </button>

                    <reporting-restrictions-group :restrictionGroup="group" :user="user"></reporting-restrictions-group>
                </div>

                <div class="extendable-card-list__empty" v-if="!restrictionGroups.length">
                    <alert type="info">
                        {{ trans('vuetables.label.noResults') }}
                    </alert>
                </div>

                <div class="extendable-card-list__add">
                    <button @click.prevent="addRestrictionGroup" :title="trans('buttons.add')">
                        <div class="icon-button icon-button--primary">
                            <div class="icon-button__icon">
                                <img src="/images/icons/create.svg" alt="">
                            </div>
                        </div>
                    </button>
                </div>
            </div>

            <div class="page-control">
                <div class="page-control__element page-control__element--margin-top">
                    <button type="button" @click="submit" :disabled="disableSubmitButton" class="btn btn--big btn--primary">{{ trans('buttons.submit') }}</button>
                </div>
        </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        'user': {
            type: Object,
            default: false
        },
        'restrictions': {
            type: Array,
            default: false
        },
    },

    data() {
        return {
            removeArray: [],
            restrictionGroups: this.restrictions.length ? this.restrictions : [],
        };
    },

    computed: {
        disableSubmitButton() {
            for (let group of this.restrictionGroups) {
                for (let item of group.items) {
                    if (item.type == null || item.restriction == null) {
                        return true;
                    }
                }
            }
            return false;
        },
    },

    methods: {
        submit() {
            axios
            .post(this.route('tenantapi.users.reporting_restrictions.store', {'user': this.user.id}), {
                '_token': this.csrf,
                'restriction_groups': this.restrictionGroups,
            })
            .then((response) => {
                this.restrictionGroups = response.data.data
                this.flash(response);
            })
            .catch(() => {
            });
        },

        removeRestriction(id) {
            this.removeArray.push(id);
        },

        addRestrictionGroup() {
            var addGroup = {};
            addGroup.id = null;
            addGroup.name = 'Filtergruppe ' + (this.restrictionGroups.length+1);
            addGroup.items = [];
            this.restrictionGroups.push(addGroup);
        },

        getRestrictions() {
            axios.get(this.route('tenantapi.users.reporting_restrictions.get', {'user': this.user.id}))
                .then((response) => {
                    this.restrictionGroups = response.data.data;
                })
                .catch(() => {
                });
        },

        removeCard(index) {
            this.restrictionGroups.splice(index,1);
        },
    },
};
</script>
